import { DateTime } from 'luxon'

export class Royalty {
	public id: number
	public name: string
	public default: boolean
	public createdAt?: DateTime
	public updatedAt?: DateTime

	constructor(data: {
		id: number
		name: string
		default: boolean
		createdAt?: DateTime
		updatedAt?: DateTime
	}) {
		this.id = data.id
		this.name = data.name
		this.default = data.default
		this.createdAt = data.createdAt
		this.updatedAt = data.updatedAt
	}

	static create(data: Partial<Royalty>): Royalty {
		const defaultData: Royalty = {
			id: 0,
			name: '',
			default: false,
		}

		return new Royalty({ ...defaultData, ...data })
	}
}
